module.exports = __webpack_public_path__ + "img/scratchy_cpg.c645ce75.jpg";